<template>
  <el-dropdown trigger="click" @command="handleLanguage">
    <span>
      <cnd-icon name="cnd-language" />
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(item, index) in languageList"
        :key="index"
        :disabled="language === item.code"
        :command="item.code"
      >
        {{ item.value }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'HeaderLanguage',
  props: {
    // 语言数据
    languageList: {
      type: Array,
      default: () => []
    },
    // 默认语言
    language: {
      type: String,
      default: 'zh_CN'
    }
  },
  methods: {
    // 选择语言
    handleLanguage(v) {
      this.$emit('handleLanguage', v)
    }
  }
}
</script>
